import { when } from '@execonline-inc/maybe-adapter';
import { UsersIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { T } from '../../../Translations';

const Groups: React.FC = () => {
  const styles = [
    'flex items-center mr-10 lg:pb-2 block py-3.5 px-5 lg:py-0 lg:px-0 ',
    'lg:text-base text-lg font-medium cursor-pointer',
  ];
  const activeStyle = 'border-b-2 lg:cursor-teal-600 lg:border-solid border-teal-600 text-teal-600';
  return (
    <NavLink
      to="/people/groups"
      className={({ isActive }) => clsx(styles, when(isActive, activeStyle).getOrElseValue(''))}
    >
      <UsersIcon height={'30px'} />
      <T kind="Groups" />
    </NavLink>
  );
};

export default observer(Groups);
